import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import { io } from 'socket.io-client';


const Mobile = styled.div`
  display: none;
  @media only screen and (max-device-width: 480px) {
    display: flex;
    height: 96vh;
    flex-direction: column;
  }
`;

const Title = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 18px;

    display: flex;
    align-items: center;

    color: #FFFFFF;

`;

const Price = styled.div`
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    display: flex;
    align-items: center;

    color: #FFFFFF;
`;

const Subtitle = styled.div`
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    /* identical to box height */

    display: flex;
    align-items: center;

    color: #9C9C9C;
   
`;


const BlackButton = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px;
    background: #141624;
    border-radius: 100px;
`;

const RedButton = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 6px 8px;
    background: linear-gradient(90.07deg, #FF0086 29.06%, #FF002E 96.96%);
    border-radius: 8px;
`;



const Desktop = styled.div`
  display: none;
  @media (min-device-width: 481px) {
    display: flex;
    flex-direction: column;
  }
`;

export default function MarketSolo(props) {
    
    useEffect(()=>{
        
    }, []);
  
    
    return (
        <>      
        <Mobile style={{padding: 20}}>
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>

            </div>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <Title>Axie Savannah Crate <br></br>#4830</Title>
                <Subtitle>Share</Subtitle>
            </div>
            <div style={{marginTop: 20, display: 'flex', justifyContent: 'space-between', paddingBottom: 22, borderBottom: '1px solid #1C1F33'}}>
                <BlackButton>Check NFT Details</BlackButton>
                <RedButton>$805</RedButton>
            </div>           

            <div style={{display: 'flex', justifyContent: 'space-between', paddingTop: 22}}>
                <Title>Axie Infinity</Title>
                <Title>View Game</Title>
            </div>
        </Mobile>
        <Desktop style={{}}>
           
        </Desktop>
        </>
    );
}

